<div class="dialog-header">
  <h1 mat-dialog-title>
    <mat-icon>question_answer</mat-icon>
    Request Changes
  </h1>
  <button mat-icon-button (click)="onCancel()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <p>What changes would you like to see?</p>
  <div class="textarea-container">
    <textarea class="mention-textarea"
              [(ngModel)]="userPrompt" 
              rows="5"
              placeholder="Describe the changes you'd like to see in the generated YAML files. Be specific about stages, jobs, or configurations that need adjustment."></textarea>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSendFeedback()" [disabled]="!userPrompt">
    <mat-icon>send</mat-icon>
    Send Feedback
  </button>
</div>
